import { Leaf } from 'lucide-react';

export function LoadingSpinner() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-4 bg-background">
      <div className="relative flex items-center justify-center">
        {/* Outer rotating ring */}
        <div className="absolute h-14 w-14 animate-spin rounded-full border-2 border-transparent border-t-primary/60" style={{ animationDuration: '1.2s' }} />
        {/* Inner pulsing icon */}
        <div className="flex h-10 w-10 items-center justify-center rounded-xl gradient-primary shadow-glow">
          <Leaf className="h-5 w-5 text-white" />
        </div>
      </div>
      <p className="text-sm font-medium text-muted-foreground animate-pulse">Loading Velora…</p>
    </div>
  );
}